export enum SlotsActionType {
    Spin = "Spin",
    Overlay = "Overlay",
    Board = "Board",
    Balance = "Balance",
    Pick = "Pick",
    Delay = "Delay"
}
